module.exports = __webpack_public_path__ + "img/pt-34.20374556.jpg";